export default "__VITE_ASSET__2ea6c2b8__"